import endpoints from '../core/endpoints';
import request from '../core/request';
import { Platform } from '../types/constants';
import { CreateEpicRequest } from '../types/epic';
import {toast} from "react-toastify";

export const getEpic = async (reqData: { epicId: number }) => {
  const { data } = await request.get(endpoints.epic.one(reqData.epicId));
  return data;
};

export const getEpicUserstories = async (reqData: { id: number }) => {
  const data = await request.get(endpoints.epic.userstories(reqData.id));
  return data.data;
};

export const updateEpicSubtitle = async (reqData: { id: number; version: number; subId: number }) => {
  const data = await request({
    url: endpoints.epic.one(reqData.id),
    method: 'patch',
    data: {
      version: reqData.version,
      factory_subtitle_id: reqData.subId,
    },
  });
  return data;
};

export const createTask = async (reqData: { formData: any }) => {
  try {
    const { data } = await request({
      url: endpoints.task.create(),
      method: 'post',
      data: reqData.formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  } catch (err: any) {
    const errorMessage =
        err?._error_message || 'ایجاد تسک با خطا مواجه شد، لطفاً دوباره تلاش کنید.';
    toast.error(errorMessage);
    throw err;
  }
};

export const deleteTask = async (reqData: { id: number }) => {
  const data = await request({
    url: endpoints.task.delete(reqData.id),
    method: 'DELETE',
  });

  return data;
};

export const editTask = async (reqData: { id: number; title: string; version: number }) => {
  const data = await request({
    url: endpoints.task.edit(reqData.id),
    method: 'PATCH',
    data: {
      subject: reqData.title,
      version: reqData.version,
    },
  });

  return data;
};

export const createEpic = async (reqData: CreateEpicRequest) => {
  // const platform: Platform = JSON.parse(Cookies.get('platform') || '{}');
  const platform: Platform = JSON.parse(localStorage.getItem('platform') || "{}")
  const { data } = await request({
    url: endpoints.epic.create,
    method: 'post',
    data: {
      factory_movie_id: reqData.movieId,
      factory_movie_language: reqData.language,
      factory_subtitle_id: reqData.subId,
      factory_movie_time: reqData.duration,
      factory_movie_creator: reqData.uploader,
      tags: reqData.tags,
      subject: reqData.title,
      project: platform.id,
    },
  });

  return data;
};

export const qcDone = async (reqData: { movieId: number; epicId: number }) => {
  const data = {
    factory_movie_id: reqData.movieId,
    epic_id: reqData.epicId,
  };
  const resp = await request({
    url: endpoints.epic.qcDone,
    method: 'POST',
    data,
  });

  return resp;
};

export const getMovie = async (reqData: { movieId: number }) => {
  const data: any = await request.get(endpoints.epic.getMovie(reqData.movieId));
  return data?.data?.message?.url;
};
